import React from 'react';
import {useLocation} from 'wouter';

import {hashToObject} from '../../../../hooks/object-hash';
import {useUrlSearchValue, UrlSearchParam} from '../../../../hooks/use-search-params';
import {SearchData} from '../../common/sidebar-search-field/interface';

interface Props {
    setSearchData: (data: SearchData) => void;
}

// implements 'copy link to this search' functionality, see copy-search-button
export function useSearchDataFromUrl(props: Props) {
    const [location, navigate] = useLocation();
    const searchValue = useUrlSearchValue(UrlSearchParam.search);

    const searchDataFromUrl = React.useMemo(
        () => searchValue.value && (hashToObject(searchValue.value) as SearchData),
        [searchValue.value]
    );

    React.useEffect(() => {
        if (searchDataFromUrl) {
            props.setSearchData(searchDataFromUrl);
            navigate(location, {replace: true});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return searchDataFromUrl;
}
